import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getOperatorDetalization = (params) => {
    return axios.get(`${backendHost}/api/admin/operator/detalizaton`, {params});
};

export {
    getOperatorDetalization
}